// @ts-nocheck
/* eslint-enable */
import React from 'react';
import Text from 'app/shared/core/Text';
import TextOverflow from 'app/shared/modules/TextOverflow';
import Center from 'app/shared/modules/Center';
import LinkController from 'app/shared/modules/LinkController';
import Card from 'app/shared/modules/Card';
import 'app/shared/modules/state-page/AreaCard.scss';
import cx from 'classnames';

class AreaCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { name, link, phrase, hidden, showCitySitemapLink, citySitemapLink, srpLinkText } = this.props;

    if (showCitySitemapLink && citySitemapLink) {
      // Dual link layout for cities
      return (
        <Card
          className={cx({
            'AreaCard-hidden': hidden,
            AreaCard: true,
          })}
        >
          <Center>
            {/* Primary link: City sitemap */}
            <LinkController to={citySitemapLink}>
              <Text size="lg">
                <TextOverflow>{name}</TextOverflow>
              </Text>
            </LinkController>
            {/* Secondary link: SRP */}
            <LinkController to={link}>
              <Text className="AreaCard-subtle">{srpLinkText || phrase}</Text>
            </LinkController>
          </Center>
        </Card>
      );
    }

    // Default single link layout for non-cities
    return (
      <Card
        className={cx({
          'AreaCard-hidden': hidden,
          AreaCard: true,
        })}
      >
        <LinkController to={link}>
          <Center>
            <Text size="lg">
              <TextOverflow>{name}</TextOverflow>
            </Text>
            <Text className="AreaCard-subtle">{phrase}</Text>
          </Center>
        </LinkController>
      </Card>
    );
  }
}

export default AreaCard;
